import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  // Método para formatear una fecha a 'YYYY-MM-DD' o devolver null si es inválida
  formatDate(date: Date | null | undefined): string | null {
    if (!date || isNaN(date.getTime())) {
      return null;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Método para validar fechas obligatorias, lanza error si es inválida
  validateRequiredDate(date: Date | null | undefined, errorMessage: string): string {
    if (!date || isNaN(date.getTime())) {
      throw new Error(errorMessage);
    }
    return this.formatDate(date) as string;
  }

  //  Método para formatear una fecha a 'YYYY-MM-DD HH:MI'
  formatDateTime(date: string | Date): string {
    if (!date) {
      return 'N/A';
    }

    const d = new Date(date);

    const day = ('0' + d.getDate()).slice(-2);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();

    const hours = ('0' + d.getHours()).slice(-2);
    const minutes = ('0' + d.getMinutes()).slice(-2);

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  formatDates(formValues: any, dateFields: string[]): any {
    const formattedValues = { ...formValues };

    dateFields.forEach((field) => {
      if (formattedValues[field]) {
        const date = new Date(formattedValues[field]);
        formattedValues[field] = this.formatDate(date);
      }
    });

    return formattedValues;
  }

  // Método para formatear una fecha a 'DD-MM-YYYY' o devolver null si es inválida
  formatDateReverse(date: Date | null | undefined): string | null {
    if (!date || isNaN(date.getTime())) {
      return null;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}-${month}-${year}`;
  }
}
